/* eslint-disable react/jsx-one-expression-per-line */
import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const agencyId = useHookstate<number | null>(null)
  const dispatchGroupId = useHookstate<number | null>(null)
  const deviceTypeId = useHookstate<number | null>(null)
  const forceRefresh = useHookstate(false)
  const station = useHookstate<string | null>(null)
  const workShiftTypeId = useHookstate<number | null>(null)

   useEffect(() => {
      document.title = translate('Resources - Dispatch System')
    }, [])

  const workShiftFilter = [
    {
      name: 'name',
      type: 'name',
      placeholder: 'workShift name',
      variable: station,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="work-shift"
        title="Turnos de Trabalho"
        disableColumnsFilters
        viewTitle="Turnos de Trabalho"
        canView={true}
        showInViewMore={['name', 'work_hours', 'rest_hours', 'created_at']}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={workShiftFilter}
        clearFilters={() => {
          agencyId.set(null)
          dispatchGroupId.set(null)
          deviceTypeId.set(null)
          station.set('')

          forceRefresh.set(!forceRefresh.get())
        }}
        notSortable={[
          'dispatch_group:name',
          'agency:name',
          'workShiftType:name',
          'device:name',
        ]}
        forceOrderColumns={['name', 'work_hours', 'rest_hours']}
        exceptColumns={[
          'work_shift_type_id',
          'agency_id',
          'device_id',
          'dispatch_group_id',
          'is_connected',
          'device_status_id',
          'brand',
          'imei',
          'model',
          'tracking_id',
          'task',
          'out_of_service',
          'acronym',
          'status',
          'identification',
          'plate',
        ]}
      />
    </Layout>
  )
}
